/**
 * Maps a duration in minutes to a schema.org/Duration type.
 */
export const mapMinutesToDurationSchema = (minutes) => {
    return `PT${minutes}M`;
};
